import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { get_POWERS_OF_TEN1o6pqgdjh70q1 as get_POWERS_OF_TEN } from '../../math.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  format$default2wn8ht1tr5xi2 as format$default,
  FormatterStructure1ss012tmsg37r as FormatterStructure,
} from './Formatter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SignedIntFormatterStructureClass;
function SignedIntFormatterStructure() {
  if (SignedIntFormatterStructureClass === VOID) {
    class $ {
      constructor(number, zeroPadding, outputPlusOnExceededWidth) {
        this.f22_1 = number;
        this.g22_1 = zeroPadding;
        this.h22_1 = outputPlusOnExceededWidth;
        // Inline function 'kotlin.require' call
        if (!(this.g22_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.g22_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.g22_1 <= 9)) {
          var message_0 = 'The minimum number of digits (' + this.g22_1 + ') exceeds the length of an Int';
          throw IllegalArgumentException().a1(toString(message_0));
        }
      }
      x21(obj, builder, minusNotRequired) {
        var innerBuilder = StringBuilder().d1();
        // Inline function 'kotlin.let' call
        var it = this.f22_1(obj);
        var number = minusNotRequired && it < 0 ? -it | 0 : it;
        if (!(this.h22_1 == null) && number >= get_POWERS_OF_TEN()[this.h22_1]) {
          innerBuilder.xb(_Char___init__impl__6a9atx(43));
        }
        // Inline function 'kotlin.math.absoluteValue' call
        if (abs(number) < get_POWERS_OF_TEN()[this.g22_1 - 1 | 0]) {
          if (number >= 0) {
            innerBuilder.yg(number + get_POWERS_OF_TEN()[this.g22_1] | 0).dh(0);
          } else {
            innerBuilder.yg(number - get_POWERS_OF_TEN()[this.g22_1] | 0).dh(1);
          }
        } else {
          innerBuilder.yg(number);
        }
        builder.e1(innerBuilder);
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure()]);
    SignedIntFormatterStructureClass = $;
  }
  return SignedIntFormatterStructureClass;
}
var UnsignedIntFormatterStructureClass;
function UnsignedIntFormatterStructure() {
  if (UnsignedIntFormatterStructureClass === VOID) {
    class $ {
      constructor(number, zeroPadding) {
        this.i22_1 = number;
        this.j22_1 = zeroPadding;
        // Inline function 'kotlin.require' call
        if (!(this.j22_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.j22_1 + ') is negative';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.j22_1 <= 9)) {
          var message_0 = 'The minimum number of digits (' + this.j22_1 + ') exceeds the length of an Int';
          throw IllegalArgumentException().a1(toString(message_0));
        }
      }
      x21(obj, builder, minusNotRequired) {
        var num = this.i22_1(obj);
        var numberStr = num.toString();
        // Inline function 'kotlin.repeat' call
        var times = this.j22_1 - numberStr.length | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            builder.xb(_Char___init__impl__6a9atx(48));
          }
           while (inductionVariable < times);
        builder.e1(numberStr);
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure()]);
    UnsignedIntFormatterStructureClass = $;
  }
  return UnsignedIntFormatterStructureClass;
}
var StringFormatterStructureClass;
function StringFormatterStructure() {
  if (StringFormatterStructureClass === VOID) {
    class $ {
      constructor(string) {
        this.k22_1 = string;
      }
      x21(obj, builder, minusNotRequired) {
        builder.e1(this.k22_1(obj));
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'StringFormatterStructure', VOID, VOID, [FormatterStructure()]);
    StringFormatterStructureClass = $;
  }
  return StringFormatterStructureClass;
}
var DecimalFractionFormatterStructureClass;
function DecimalFractionFormatterStructure() {
  if (DecimalFractionFormatterStructureClass === VOID) {
    class $ {
      constructor(number, minDigits, maxDigits, zerosToAdd) {
        this.l22_1 = number;
        this.m22_1 = minDigits;
        this.n22_1 = maxDigits;
        this.o22_1 = zerosToAdd;
        var containsArg = this.m22_1;
        // Inline function 'kotlin.require' call
        if (!(1 <= containsArg ? containsArg <= 9 : false)) {
          var message = 'The minimum number of digits (' + this.m22_1 + ') is not in range 1..9';
          throw IllegalArgumentException().a1(toString(message));
        }
        var containsLower = this.m22_1;
        var containsArg_0 = this.n22_1;
        // Inline function 'kotlin.require' call
        if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
          var message_0 = 'The maximum number of digits (' + this.n22_1 + ') is not in range ' + this.m22_1 + '..9';
          throw IllegalArgumentException().a1(toString(message_0));
        }
      }
      x21(obj, builder, minusNotRequired) {
        var number = this.l22_1(obj);
        var numberWithRequiredPrecision = number.a1x(this.n22_1);
        var zerosToStrip = 0;
        while (this.n22_1 > (this.m22_1 + zerosToStrip | 0) && (numberWithRequiredPrecision % get_POWERS_OF_TEN()[zerosToStrip + 1 | 0] | 0) === 0) {
          zerosToStrip = zerosToStrip + 1 | 0;
        }
        var zerosToAddBack = this.o22_1.q1((this.n22_1 - zerosToStrip | 0) - 1 | 0);
        if (zerosToStrip >= zerosToAddBack)
          zerosToStrip = zerosToStrip - zerosToAddBack | 0;
        var digitsToOutput = this.n22_1 - zerosToStrip | 0;
        var numberToOutput = numberWithRequiredPrecision / get_POWERS_OF_TEN()[zerosToStrip] | 0;
        builder.e1(substring((numberToOutput + get_POWERS_OF_TEN()[digitsToOutput] | 0).toString(), 1));
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'DecimalFractionFormatterStructure', VOID, VOID, [FormatterStructure()]);
    DecimalFractionFormatterStructureClass = $;
  }
  return DecimalFractionFormatterStructureClass;
}
var ConstantStringFormatterStructureClass;
function ConstantStringFormatterStructure() {
  if (ConstantStringFormatterStructureClass === VOID) {
    class $ {
      constructor(string) {
        this.p22_1 = string;
      }
      x21(obj, builder, minusNotRequired) {
        builder.e1(this.p22_1);
      }
    }
    protoOf($).b1u = format$default;
    initMetadataForClass($, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure()]);
    ConstantStringFormatterStructureClass = $;
  }
  return ConstantStringFormatterStructureClass;
}
//region block: exports
export {
  ConstantStringFormatterStructure as ConstantStringFormatterStructure25vvm6os5tq8f,
  DecimalFractionFormatterStructure as DecimalFractionFormatterStructure2fby7dmyhkzn1,
  SignedIntFormatterStructure as SignedIntFormatterStructureuogj4y4pj858,
  StringFormatterStructure as StringFormatterStructure3i97mc47fm0qc,
  UnsignedIntFormatterStructure as UnsignedIntFormatterStructure2iqfxgv3d2ejy,
};
//endregion

//# sourceMappingURL=FormatterOperation.mjs.map
